module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            i: moduleId,
            /******/
            l: !1,
            /******/
            exports: {}
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.l = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // define getter function for harmony exports
    /******/
    /******/
    /******/
    // getDefaultExport function for compatibility with non-harmony modules
    /******/
    /******/
    /******/
    // Object.prototype.hasOwnProperty.call
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.d = function(exports, name, getter) {
        /******/
        __webpack_require__.o(exports, name) || /******/
        Object.defineProperty(exports, name, {
            /******/
            configurable: !1,
            /******/
            enumerable: !0,
            /******/
            get: getter
        });
    }, __webpack_require__.n = function(module) {
        /******/
        var getter = module && module.__esModule ? /******/
        function() {
            return module.default;
        } : /******/
        function() {
            return module;
        };
        /******/
        /******/
        return __webpack_require__.d(getter, "a", getter), getter;
    }, __webpack_require__.o = function(object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var MESSAGES;
    !function(MESSAGES) {
        MESSAGES.ERROR = "ERROR", MESSAGES.MODULE_CHANGE = "MODULE_CHANGE", MESSAGES.MODULE_CHANGE_REQUEST = "MODULE_CHANGE_REQUEST", 
        MESSAGES.NAVIGATE_TO_LANDING_REQUEST = "NAVIGATE_TO_LANDING_REQUEST", MESSAGES.LOADING_SPINNER_REQUEST = "LOADING_SPINNER_REQUEST", 
        MESSAGES.SET_CURRENT_CLASS_GROUP = "SET_CURRENT_CLASS_GROUP", MESSAGES.LOGOUT_REQUEST = "LOGOUT_REQUEST", 
        MESSAGES.MAKE_API_CALL = "MAKE_API_CALL", MESSAGES.DUCS_EVENT_MODAL = "DUCS_EVENT_MODAL", 
        MESSAGES.SET_DYNAMIC_PARAMS = "SET_DYNAMIC_PARAMS";
    }(MESSAGES || (MESSAGES = {}));
    var portalCommunication = {
        // The list of shared magic string codes. Used privately here, publicly by the portal to interpret incoming messages
        MESSAGES: MESSAGES,
        postPortalMessage: function(message) {
            // TODO: Node module for frame communication messages?
            // TODO: Domain checking
            top.postMessage(JSON.stringify(message), "*");
        },
        /**
     * Set the currently selected class and group. If a new module is selected, the classId and groupId will be passed to it
     * @param classId
     * @param groupId
     */
        informClassGroupSelection: function(classId, groupId) {
            portalCommunication.postPortalMessage({
                type: portalCommunication.MESSAGES.SET_CURRENT_CLASS_GROUP,
                params: {
                    classId: classId,
                    groupId: groupId
                }
            });
        },
        /**
     * Inform the portal that the currently selected module has changed (For example, you have moved from route to another internally)
     * @param newModuleId
     */
        informModuleChange: function(newModuleId) {
            portalCommunication.postPortalMessage({
                type: portalCommunication.MESSAGES.MODULE_CHANGE,
                message: newModuleId
            });
        },
        /**
     * Inform the portal to go back to portal landing screen for currently loaded
     * module
     * @param moduleId
     */
        requestNavigateToLanding: function(moduleId) {
            portalCommunication.postPortalMessage({
                type: portalCommunication.MESSAGES.NAVIGATE_TO_LANDING_REQUEST,
                message: moduleId
            });
        },
        /**
     * Ask the portal to change the currently selected module, optionally selecting a class/group at the same time
     * @param newModuleId
     * @param [params] {object} An object containing the classId and (optionally) the groupId to select
     */
        requestModuleChange: function(newModuleId, params) {
            portalCommunication.postPortalMessage({
                type: portalCommunication.MESSAGES.MODULE_CHANGE_REQUEST,
                message: newModuleId,
                params: params
            });
        },
        /**
     * Show or hide the loading spinner. This should be called with false on every route that can be accessed by the portal, and then turned on/off as needed
     * @param isLoading {boolean} True shows the spinner, false hides it
     */
        requestLoadingSpinner: function(isLoading) {
            portalCommunication.postPortalMessage({
                type: portalCommunication.MESSAGES.LOADING_SPINNER_REQUEST,
                message: isLoading
            });
        },
        /**
     * Request the portal alert the user of a server error (Unexpected 500)
     */
        requestServerError: function() {
            portalCommunication.postPortalMessage({
                type: portalCommunication.MESSAGES.ERROR,
                message: "_SERVER_ERROR_"
            });
        },
        /**
     * Request the portal alert the user to an expired token error
     */
        requestSessionError: function() {
            portalCommunication.postPortalMessage({
                type: portalCommunication.MESSAGES.ERROR,
                message: "_SESSION_EXPIRED_"
            });
        },
        /**
     * Request the portal to logout
     * @param logoutUrl
     */
        logout: function(logoutUrl) {
            portalCommunication.postPortalMessage({
                type: portalCommunication.MESSAGES.LOGOUT_REQUEST,
                message: logoutUrl
            });
        },
        /**
     * Inform the portal to make an api call based on apiType
     * @param [params] {object} An object containing the productId and apiType to select
     */
        informMakeAPICall: function(params) {
            portalCommunication.postPortalMessage({
                type: portalCommunication.MESSAGES.MAKE_API_CALL,
                params: params
            });
        },
        /**
     * Request the portal to open ducs event modal
     */
        requestDucsModal: function(arrayGirlId) {
            portalCommunication.postPortalMessage({
                type: portalCommunication.MESSAGES.DUCS_EVENT_MODAL,
                message: arrayGirlId
            });
        },
        setDynamicParams: function(_a) {
            var _b, id = _a.id, value = _a.value;
            portalCommunication.postPortalMessage({
                type: MESSAGES.SET_DYNAMIC_PARAMS,
                message: (_b = {}, _b[id] = value, _b)
            });
        }
    };
    exports.default = portalCommunication;
} ]);


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/mathletics-portal-communication-service/dist/bundle.js
// module id = UTT2
// module chunks = 0